import authService from "@/backend/services/auth";
import router from "@/router";
import store from "@/store/store";

export default {
  async executeStart({ commit, dispatch }, params = null) {
    return new Promise((resolve, reject) => {
      authService
        .start(params)
        .then((response) => {
          commit("setStart", response);
          commit("isStarting", false);
          // Pass in_page to executePing so redirect happens after isLoggedIn is confirmed
          const inPage = response?.in_page ?? null;
          dispatch("executePing", inPage);
          resolve(response);
        })
        .catch((error) => {
          // Even if start fails, set isStarting to true so the app can render
          commit("isStarting", true);
          console.error("Auth start error:", error);
          reject(error);
        });
    });
  },
  async executePing({ commit, dispatch }, inPage = null) {
    return new Promise((resolve, reject) => {
      authService
        .ping()
        .then((response) => {
          if (
            response &&
            response.login_token_valid &&
            response.login_token_valid == false
          ) {
            resolve(dispatch("logout"));
          } else {
            commit("setPing", response);
            store.dispatch("account/setLoggedIn", response);
            commit("isStarting", true);
            if (inPage) {
              dispatch("redirectAfterLoginSuccess", inPage);
            }
            resolve(response);
          }
        })
        .catch((error) => {
          console.error('executePing error:', error);
          reject(error);
        });
    });
  },
  redirectAfterLoginSuccess(context, page) {
    
    // Universal: redirect to any path that starts with /
    if (typeof page === 'string' && page.startsWith('/')) {
      const route = router.resolve({ path: page });
      if (route.path !== router.currentRoute.value.path) {
        router.push(route);
      }
    }
  },
  async redirectToLoginPage({ commit, rootGetters }, data) {
    setTimeout(async () => {
      let isStarting = rootGetters["auth/isStarting"];
      const isLoggedIn = rootGetters["account/isLoggedIn"];

    if (isLoggedIn === false) {
      // Universal solution: always use the current route path as in_page
        const currentPath = router.currentRoute.value.path;
        commit("setReturnUrl", globalThis.location.origin + currentPath);
        const loginParams = { in_page: currentPath };
        if (isStarting) {
          
          let loginData = await authService.getLoginData(loginParams).catch((err) => {
            console.error('getLoginData error:', err);
            throw err;
          });
          
          globalThis.location.href = loginData.url
        }
      }
    }, 2000);
  },
  async getLogoutCookie() {
    return await authService.getLogoutCookie();
  },
  async logoutComplete({ dispatch }) {
    const currentRoute = router.currentRoute;
    if (currentRoute.meta && currentRoute.meta.requiresAuth === true) {
      await dispatch("getLogoutCookie");
      globalThis.location.reload();
    } else {
      // No login required
      await authService.deleteLoginCookie();
      await dispatch("getLogoutCookie");
    }
  },
};
